import { useCallback } from "react";

import { Checkbox } from "@prequel/shared-components";

type EventCheckboxProps = {
  event: string;
  checked: boolean;
  onChange: (event: string, isChecked: boolean) => void;
  disabled: boolean;
};

const EventCheckbox = ({ event, checked, onChange, disabled }: EventCheckboxProps) => {
  const handleChange = useCallback((isChecked: boolean) => onChange(event, isChecked), [event, onChange]);

  return <Checkbox id={event} label={event} checked={checked} setChecked={handleChange} disabled={disabled} />;
};

export default EventCheckbox;
